"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TinyTransition = function (_React$Component) {
  _inherits(TinyTransition, _React$Component);

  function TinyTransition() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TinyTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TinyTransition.__proto__ || Object.getPrototypeOf(TinyTransition)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      children: _this.props.disableInitialAnimation ? _this.props.children : null
    }, _this.isAnimating = false, _this.waitForNode = function (callback) {
      if (!_this) {
        return;
      }

      var node = _reactDom2.default.findDOMNode(_this);

      if (node) {
        callback(node);
      } else {
        _this.raf = requestAnimationFrame(function () {
          _this.waitForNode(callback);
        });
      }
    }, _this.clearTimers = function () {
      cancelAnimationFrame(_this.raf);
      clearTimeout(_this.animationTimer);
      clearTimeout(_this.delayTimer);
      _this.isAnimating = false;
    }, _this.animateIn = function () {
      if (!(0, _utils.canAnimate)()) {
        _this.setState({
          children: _this.props.children
        });

        return;
      }

      _this.clearTimers();

      _this.isAnimating = true;
      _this.delayTimer = setTimeout(function () {
        _this.setState({
          children: _this.props.children
        }, function () {
          var classNames = _this.props.classNames;

          _this.waitForNode(function (node) {
            (0, _utils.resetClassList)(node, classNames);
            node.classList.add(classNames.beforeEnter);
            _this.raf = requestAnimationFrame(function () {
              _this.raf = requestAnimationFrame(function () {
                node && node.classList.add(classNames.entering);
              });
            });
            _this.animationTimer = setTimeout(function () {
              node && (0, _utils.resetClassList)(node, classNames);
              _this.isAnimating = false;

              _this.setState({});
            }, _this.props.duration);
          });
        });
      }, _this.props.delay);
    }, _this.animateOut = function () {
      if (!(0, _utils.canAnimate)()) {
        _this.setState({
          children: _this.props.children
        });

        return;
      }

      var node = _reactDom2.default.findDOMNode(_this);

      var classNames = _this.props.classNames;

      if (!node) {
        return;
      }

      _this.clearTimers();

      _this.isAnimating = true;
      _this.delayTimer = setTimeout(function () {
        node && (0, _utils.resetClassList)(node, classNames);
        node && node.classList.add(classNames.beforeLeave);
        _this.raf = requestAnimationFrame(function () {
          node && node.classList.add(classNames.leaving);
        });
        _this.animationTimer = setTimeout(function () {
          _this.isAnimating = false;

          _this.setState({
            children: _this.props.children
          });
        }, _this.props.duration);
      }, _this.props.delay);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TinyTransition, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.children && !this.props.disableInitialAnimation) {
        this.raf = requestAnimationFrame(function () {
          _this2.animateIn();
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimers();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var newChildren = _react.Children.toArray(this.props.children);

      var oldChildren = _react.Children.toArray(prevProps.children);

      if (newChildren.length !== oldChildren.length) {
        if (newChildren.length) {
          this.animateIn();
        } else {
          this.animateOut();
        }
      } else if (this.props.children !== this.state.children && !this.isAnimating) {
        this.setState({
          children: this.props.children
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.children;
    }
  }]);

  return TinyTransition;
}(_react2.default.Component);

TinyTransition.propTypes = {
  children: _propTypes2.default.node,
  classNames: _propTypes2.default.shape({
    beforeEnter: _propTypes2.default.string,
    entering: _propTypes2.default.string,
    beforeLeave: _propTypes2.default.string,
    leaving: _propTypes2.default.string
  }),
  disableInitialAnimation: _propTypes2.default.bool,
  delay: _propTypes2.default.number,
  duration: _propTypes2.default.number.isRequired
};
TinyTransition.defaultProps = {
  children: null,
  classNames: {
    beforeEnter: "before-enter",
    entering: "entering",
    beforeLeave: "before-leave",
    leaving: "leaving"
  },
  duration: 500,
  delay: 0
};
exports.default = TinyTransition;